import ImageShowCasePhysicalStep01 from 'assets/images/showCase/showcase-physical-step-01.svg';
import ImageShowCasePhysicalStep02 from 'assets/images/showCase/showcase-physical-step-02.svg';

const getShowCasePhysicalElementsSteps = () => {
  return [
    {
      title: 'Tem novidade no Checkout Elements!',
      description:
        'Agora você também pode oferecer produtos físicos em suas páginas de vendas. Simples, prático e rastreável, como um checkout embedado deve ser. 😉',
      image: ImageShowCasePhysicalStep01,
      primaryButtonText: 'Próximo',
      secondaryButtonText: 'Agora não'
    },
    {
      title: 'Tem novidade no Checkout Elements!',
      description:
        'Para adicionar seu produto físico no Checkout Elements é rapidinho. Basta você acessar a área de edição do produto, selecionar o formato que deseja, copiar o script e colar em sua página de vendas!',
      image: ImageShowCasePhysicalStep02,
      primaryButtonText: 'Ok, entendi',
      secondaryButtonText: 'O que é o Checkout Elements?'
    }
  ];
};

export default getShowCasePhysicalElementsSteps;
